<template>

    <div class="min-h-screen flex flex-col px-2">
        <vue-disqus shortname="live-storm-chasing" :identifier="streamId" v-if="streamId !== null"></vue-disqus>
    </div>

</template>

<script>

    export default {
        name: 'home',
        data() {
            return {
                streamId: null,
            }
        },
        mounted() {
            this.streamId = this.$route.params.streamId
        },
    }

</script>
